import {Component, ElementRef, Inject, inject, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import * as fromReducers from '../core/store/reducers';
import {AuthService} from '../core/services/api/auth.service';
import {LoadUserAction} from '../core/store/actions/user.actions';
import {LogService} from '../core/services/utility/log.service';
import {AdsService} from '../core/services/ads.service';
import {Router, NavigationEnd} from '@angular/router';
import {UrlService} from '../core/services/url.service';
import {ChatbotRestService} from '../core/services/api/chatbot.rest-service';
import { ChatbotService } from '../core/services/chatbot.service';

@Component({
    selector: 'app-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss'],
    standalone: false
})
export class ViewComponent implements OnInit, OnDestroy {
    public authenticated = false;
    public userLoading$: Observable<boolean>; // getUserLoading
    public count = 10;
    private ngUnsubscribe$ = new Subject<void>();
    public ads;
    public currentRoute = null;
    chatbotRestService = inject(ChatbotRestService);
    chtbotService = inject(ChatbotService);
    navref;


    constructor(
        public store: Store<fromReducers.State>,
        @Inject(AuthService) public auth: AuthService,
        @Inject(LogService) public log: LogService,
        @Inject(AdsService) public adService: AdsService,
        @Inject(UrlService) public urlService: UrlService,
        private elementRef: ElementRef,
        public router: Router
    ) {
        // dispatch action to load user into store via effect
        const token = this.auth.getToken();
        console.log('view component')
        if (token) {
            this.store.dispatch(new LoadUserAction());
            this.userLoading$ = this.store.pipe(select(fromReducers.getUserLoading));
            this.userLoading$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((loading: boolean) => {
                if (loading === false) {
                    // check user on every call, because he may have logged out on another system
                    this.authenticated = this.auth.isAuthenticated();
                    this.log.info('view.component:constructor:isAuthenticated: ' + this.authenticated);

                    if (!this.authenticated) {
                        // window.location.href = this.LOGIN;
                        console.log('not authenticated')
                    }
                }
            });
        } else {
            this.urlService.lastUrl = 'logout';
            this.router.navigate(['/login'], {queryParams: {returnUrl: this.router.url}});
        }
    }

    isOnDashboard() {
        return this.router.url.startsWith('/dashboard');
    }

    ngOnInit() {
        this.urlService.setCurrentPath(this.router.url);

        this.chatbotRestService.getChatbotToken().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
            if (response.returnObject) {
                this.chtbotService.setChatbotToken(response.returnObject);
            }
        });
    }

    /**
     * Unsubscribe from all subscriptions.
     */
    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}